import gql from "graphql-tag";
import {responseField} from "../../../../base.graphql";

export const regionGqlFields = `
  id
  uniqueId
  name
  code
`;


export const ALL_REGIONS = gql`
query GetAllRegions {
  getAllRegions {
    response {
      ${responseField}
    }
    data {
      ${regionGqlFields}
    }
  }
}
`
